<template>
  <section id="approach" class="approach">
    <div class="container">
      <h1>Approach</h1>
      <div class="approach-content">
        <flickity ref="flickity" :options="flickityOptions">
          <div class="approach-step approach-step--one">
            <h2>1.</h2>
            <div class="approach-step-content">
              <h2>Research</h2>
              <p>We love all things Marketing and making your life simpler, more exciting and colourful, by finding your niche through industry research.</p>
            </div>
          </div>
          <div class="approach-step approach-step--two">
            <h2>2.</h2>
            <div class="approach-step-content">
              <h2>Get To Know You</h2>
              <p>Not only do we get to know your business, but you too, making sure your passion and commitment while providing you with the greatest solutions / proposals.</p>
            </div>
          </div>
          <div class="approach-step approach-step--three">
            <h2>3.</h2>
            <div class="approach-step-content">
              <h2>We Focus on What we Good at</h2>
              <p>No one likes to be mediocre, so let’s agree on a path that will take your business / project to new heights - the sky is the limit.</p>
            </div>
          </div>
          <div class="approach-step approach-step--four">
            <h2>4.</h2>
            <div class="approach-step-content">
              <h2>Teamwork</h2>
              <p>Our range of services will assist you from set-up to strike, from a brainwave WhatsApp message to an analysis of the success that we have reached together.</p>
            </div>
          </div>
          <div class="approach-step approach-step--five">
            <h2>5.</h2>
            <div class="approach-step-content">
              <h2>Open & Easy Going</h2>
              <p>We guarantee an open door policy, to continue working until you are fully satisfied.</p>
            </div>
          </div>
          <div class="approach-step approach-step--five">
            <h2>6.</h2>
            <div class="approach-step-content">
              <h2>Convenience</h2>
              <p>We will get to work, whilst you continue making the money.</p>
            </div>
          </div>
        </flickity>
        <ul class="approach-navigation">
          <li v-hover :class="{'active' : selectedIndex === 0}" @click="goToIndex(0)">
            <p>1.</p>
          </li>
          <li v-hover :class="{'active' : selectedIndex === 1}" @click="goToIndex(1)">
            <p>2.</p>
          </li>
          <li v-hover :class="{'active' : selectedIndex === 2}" @click="goToIndex(2)">
            <p>3.</p>
          </li>
          <li v-hover :class="{'active' : selectedIndex === 3}" @click="goToIndex(3)">
            <p>4.</p>
          </li>
          <li v-hover :class="{'active' : selectedIndex === 4}" @click="goToIndex(4)">
            <p>5.</p>
          </li>
          <li v-hover :class="{'active' : selectedIndex === 5}" @click="goToIndex(5)">
            <p>6.</p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import Flickity from 'vue-flickity'
export default {
  components: {
    Flickity
  },
  data () {
    return {
      flickityOptions: {
        autoPlay: false,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true
      },
      selectedIndex: 0
    }
  },
  mounted () {
    this.selectedIndex = this.$refs.flickity.selectedIndex()
    this.$refs.flickity.on('change', (index) => {
      this.selectedIndex = index
    })
  },
  methods: {
    goToIndex (index) {
      this.$refs.flickity.select(index)
    }
  }
}
</script>

<style lang="scss" scpoed>
@import '../../assets/styles/_variables';
@import "../../assets/styles/breakpoints";
.approach {
  width: 100%;
  margin: 50px 0;
  position: relative;
  height: auto;

  .carousel-cell {
    width: 100%;
  }

  &:after {
    display: block;
    position: absolute;
    z-index: -10;
    top: 0;
    left: 0;
    width: calc(((100vw - 960px) / 2) + 250px);
    height: 225px;
    content: '';
    background: $accent-block;
    @include breakpoint(md) {
      display: none;
    }
  }
  &:before {
    position: absolute;
    bottom: -20px;
    left: calc((100vw - 960px) / 2 + 150px);
    width: 3px;
    height: 40px;
    content: '';
    background: $gold;
    @include breakpoint(md) {
      display: none;
    }
  }
  .container {
    margin-bottom: 125px;
    position: relative;
    h1 {
      position: absolute;
      display: inline-block;
      font-size: 50px;
      line-height: 50px;
      color: $indigo;
      top: -25px;
      left: 0;
      font-family: 'Autography', Courier, monospace;
      @include breakpoint(md) {
        position: relative;
        left: 20px;
      }
      @include breakpoint(sm) {
        font-size: 40px;
      }
    }

    .approach-content {
      padding: 40px 40px 40px calc(250px + 40px);
      width: 100%;
      height: 225px;
      @include breakpoint(md) {
        padding: 40px 0 0 0;
      }

      .approach-step {
        width: 100%;
        display: flex;
        h2 {
          margin: 0 20px 0 0;
          font-size: 18px;
        }
        .approach-step-content {
          h2 {
            margin: 0 0 10px 0;
            font-size: 18px;
          }
          p {
            font-weight: 200;
          }
        }
      }
      .approach-navigation {
        position: relative;
        flex: 100%;
        padding-left: 60px;
        margin: 0 0 0 20px;
        cursor: pointer;
        user-select: none;

        &:before {
          position: absolute;
          top: 20px;
          left: 15px;
          height: 2px;
          width: 30px;
          content: '';
          background: $gold;
        }
        li {
          float: left;
          padding: 10px;
          color: $sage;
          &.active {
            color: $black;
          }
        }
      }
    }
  }
}
</style>
